import { I } from '../data/tokens';

export default function SectionLabel({ label }) {
  return (
    <div style={I.sectionLabelWrap}>
      <div style={I.sectionLabelLine} />
      <span style={I.sectionLabelText}>{label}</span>
    </div>
  );
}
